import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { SimpleSelect } from '@calendly/ui/components/select'
import { BodyText } from '@calendly/ui/components/typography'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { capitalize } from 'lodash-es'

import { Layout } from 'components/layout'

import { useAvailabilitySidePanelActions } from './availability_side_panel'
import { CalendarViewControl } from './calendar_view_control'

const ControlsContainer = (props) => <Layout justify="space-between" align="center" relative {...props} />

export const PendingUserAvailabilitySelect = ({ formPath }) => {
  const { openAvailabilitySidePanel } = useAvailabilitySidePanelActions()
  const isDesktopUp = useDeviceType('isDesktopUp')
  const [{ value: usingCustomHours }, _, { setValue }] = useFormField({ name: `${formPath}.usingCustomHours` })
  const [__, ___, { setValue: setRuleValue }] = useFormField({ name: `${formPath}.activeAvailabilityRuleId` })
  const selectedValue = usingCustomHours ? 'custom-hours' : 'default'

  const onChange = (value) => {
    if (value === 'default') {
      setRuleValue('default')
      setValue(false)
    } else {
      setRuleValue(null)
      setValue(true)
    }
  }

  const handleOpenCalendar = () => openAvailabilitySidePanel({ formPath, format: 'calendar' })

  return (
    <ControlsContainer>
      <Layout align="center" gap="4">
        <BodyText size="medium" weight="bold">
          {I18n.t('publisher.event_type_editor.sections.availability.schedule.title')}
          {': '}
        </BodyText>
        <SimpleSelect
          aria-label={I18n.t('publisher.event_type_editor.sections.availability.schedule.title')}
          variant="minimal"
          value={selectedValue}
          onChange={onChange}
          options={[
            { value: 'default', name: capitalize(I18n.t('publisher.availability.schedules.default_schedule')) },
            { value: 'custom-hours', name: I18n.t('publisher.event_type_editor.sections.available_hours.custom_hours_label') }
          ]}
        />
      </Layout>
      {usingCustomHours && isDesktopUp && <CalendarViewControl onClick={handleOpenCalendar} />}
    </ControlsContainer>
  )
}
